import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// ✅ Import depuis free-brands-svg-icons
import { 
  faFacebook, 
  faWhatsapp, 
  faLinkedin, 
  faTiktok 
} from '@fortawesome/free-brands-svg-icons';
// Icônes pour les compétences (solid)
import { 
  faCheckCircle, 
  faClipboardList,
  faBuilding,
  faRoad,
  faPencilRuler,
  faMap
} from '@fortawesome/free-solid-svg-icons';
import './DepartmentAbout.css';

const iconMap = {
  facebook: faFacebook,
  whatsapp: faWhatsapp,
  linkedin: faLinkedin,
  tiktok: faTiktok,
};

// Map des icônes pour les compétences (on peut personnaliser par label)
const skillIconMap = {
  'ÉTUDES TECHNIQUES': faClipboardList,
  'BÂTIMENT': faBuilding,
  'TRAVAUX PUBLICS': faRoad,
  'ARCHITECTURE': faPencilRuler,
  'TOPOGRAPHIE & GEOMATIQUE': faMap,
  // Ajoute d'autres correspondances si nécessaire
};

const DepartmentAbout = ({
  chefImage,
  chefName,
  chefRole,
  chefSocial,
  logoImage,
  title,
  subtitle,
  description,
  skills, // skills est maintenant un tableau d'objets { label, color, description? }
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  // Si skills contient des pourcentages, on les transforme en tags simples
  // On suppose que skills est un tableau d'objets avec au moins 'label' et 'color'
  // On peut aussi ajouter une description optionnelle

  return (
    <section className="department-about" ref={ref}>
      <div className="container">
        <div className="department-about-grid">
          <motion.div
            className="department-about-image"
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7 }}
          >
            <div className="chef-card">
              <img src={chefImage} alt={chefName} />
              <div className="chef-info">
                <h5>{chefName}</h5>
                <span>{chefRole}</span>
                <div className="chef-social">
                  {chefSocial.map((social, index) => (
                    <a key={index} href={social.url} target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={iconMap[social.icon]} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="department-about-text"
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            {logoImage && (
              <div className="dept-logo">
                <img src={logoImage} alt="Logo département" />
              </div>
            )}
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
            <p>{description}</p>

            {/* ✅ Nouvelle présentation des compétences : tags avec icônes */}
            <div className="dept-skills-tags">
              {skills.map((skill, index) => {
                // Récupère l'icône correspondante ou utilise une icône par défaut
                const icon = skillIconMap[skill.label] || faCheckCircle;
                return (
                  <motion.div
                    key={index}
                    className="skill-tag"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={isInView ? { opacity: 1, scale: 1 } : {}}
                    transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                    style={{ borderColor: skill.color, color: skill.color }}
                  >
                    <FontAwesomeIcon icon={icon} className="skill-tag-icon" />
                    <span className="skill-tag-label">{skill.label}</span>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DepartmentAbout;